module.exports = __webpack_public_path__ + "static/img/s112.55091a24.png";